const Struct =  /* glsl */`
    struct Triangle {
        vec3 p1, p2, p3;
        vec3 n1, n2, n3;
        vec2 uv1, uv2, uv3;
        float materialIndex;
    };

    struct Material {
        vec3 emissive;
        vec3 baseColor;
        float subsurface;
        float metallic;
        float specular;
        float specularTint;
        float roughness;
        float anisotropic;
        float sheen;
        float sheenTint;
        float clearcoat;
        float clearcoatGloss;
        float IOR;
        float transmission;
        float albedoTextureIndex;
        float normalTextureIndex;
        float metallicRoughnessTextureIndex;
        float aoTextureIndex;
        float emissiveTextureIndex;
        vec2 normalScale;
        float aoIntensity;
        float alpha;
        float alphaMode;
        float doubleSided;
    };

    struct BSDFSample {
        vec3 direction;
        vec3 weight;
        float pdf;
        uint flags;
        bool valid;
    };

    struct LightSample {
        vec3 direction;
        vec3 radiance;
        float distance;
        float pdf;
        uint flags;
        bool valid;
    };
    
    struct Ray {
        vec3 origin;
        vec3 direction;
    };

    struct RayHit {
        bool isHit;
        bool isInside;
        float distance;
        vec3 position;
        vec3 normal;
        vec3 geometricNormal;
        vec3 tangent;
        vec3 bitangent;
        vec2 uv;
        float materialIndex;
        vec3 rayDirec;
        Material material;
    };

    struct BVHNode {
        vec3 aa;
        vec3 bb;
        int isLeaf;
        int left;
        int right;
        int index;
        int size;
    };
`

export { Struct };
